import { IWheelSector } from '~/actions/extraHTML/wheelOfFortune';
import { getDegree } from '~/actions/extraHTML/wheelOfFortune/helpers';
import { arrow } from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/arrow';

export interface IArrow {
  radius: number;
  arrowNumber: number;
  degree: number;
}

export const arrows = (sectors: IWheelSector[], radius: number) => {
  const degree = getDegree(sectors.length);

  const arrowsHTML = sectors.map((sector, key) => {
    const arrowProps: IArrow = {
      radius,
      arrowNumber: key + 1,
      degree,
    };

    return arrow({ ...arrowProps });
  });

  return arrowsHTML.join('');
};
